/**
 * @file Client for the `formDeriveRecomputeForm` callable: marks ONE form version for a fresh derive
 * pass. Consumer: `FormDerivedValuesPanel`, the only surface allowed to word the refusals.
 * A callable rather than a write because `formDerives` is server-owned — `firestore.rules` denies
 * every client write to it, so the drawer cannot set the flag itself.
 * `aborted` means a computation holds the version right now and trying again works; every other
 * rejection is reported as a failure. Nothing here retries: the version trigger runs the pass, so a
 * resolved call promises the request landed, never that a value changed.
 */
import { httpsCallable } from 'firebase/functions';
import { functions } from './firebaseFunctions';
import type {
  FormDeriveRecomputeFormRequest,
  FormDeriveRecomputeFormResponse,
} from '#types';

export const callFormDeriveRecomputeForm = async (
  formId: string,
  versionId: string,
): Promise<FormDeriveRecomputeFormResponse> => {
  const call = httpsCallable<FormDeriveRecomputeFormRequest, FormDeriveRecomputeFormResponse>(
    functions,
    'formDeriveRecomputeForm',
  );
  return (await call({ formId, versionId })).data;
};
